import { selectors as experimentationSelectors } from '@merchant-portal/experimentation';
import { useSetSubmenu } from '@merchant-portal/framework';
import { hooks as i18nHooks } from 'mage-i18n';
import { useCallback } from 'react';
import { useSelector } from 'react-redux';
const PLUGIN_GUIDES_EXPERIMENT_KEY = 'merchant-portal.plugin-guides.enabled';
const MENU_ITEM_ID = 'sidebar-boosters-home-fe';
export default function useSetBoostersHomeSubmenu() {
    const setSubMenu = useSetSubmenu();
    const t = i18nHooks.useTranslator();
    const isPluginGuidesEnabled = useSelector(experimentationSelectors.isFeatureToggleEnabled(PLUGIN_GUIDES_EXPERIMENT_KEY));
    const sidebarItems = [{
            label: t('home-fe.boosters-plugins.title'),
            path: '/boost/plugins',
            id: 'sidebar-boosters-home-fe-plugins'
        }];
    const negativeCallback = useCallback(() => { }, []);
    const positiveCallback = useCallback(() => setSubMenu(MENU_ITEM_ID, sidebarItems), [setSubMenu]);
    if (!isPluginGuidesEnabled)
        return negativeCallback;
    return positiveCallback;
}
